import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import logo from "assets/img/slide/logo.png";
import { LOGIN } from "constants/routes";
import { getAuth, signOut } from "firebase/auth";
import React from "react";
import { useNavigate } from "react-router";

export default function NotFound() {
  const navigate = useNavigate();

  const auth = getAuth();
  signOut(auth);

  const onClick = () => {
    navigate(LOGIN, { replace: true });
  };

  return (
    <Grid
      container
      direction="column"
      sx={{
        justifyContent: "space-around",
        alignItems: "center",
        textAlign: "center",
        minHeight: "100vh",
      }}
    >
      <Grid>
        <Box component="img" src={logo} alt="Slide" sx={{ height: 130 }} />
        <h1>404</h1>
        <h2>Page not found</h2>
        <p>Uh Oh, the page you are looking for has been removed.</p>
        <Box
          sx={{
            my: 4,
          }}
        >
          <Button onClick={onClick} variant="contained">
            Back to Safety
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
}
